import PlatformFilterOperator from "@mapmycustomers/shared/enum/PlatformFilterOperator";
import IField from "@mapmycustomers/shared/types/fieldModel/IField";
import { LegacyCombinedCondition } from "@mapmycustomers/shared/types/viewModel/internalModel/FilterModel";
import { Condition } from "@mapmycustomers/shared/types/viewModel/platformModel/PlatformFilterModel";
import { isDefined } from "@mapmycustomers/shared/util/assert";

import { isLegacySimpleCondition } from "../assert";
import { getRegularFieldConditionValue } from "../convertFromPlatformFilterModel";

// implement handing legacy filters which could have two or more filterOperators per field
// there are some other special cases with more than two filters, but those are covered
// separately (see range condition or area condition parsers)
const parseLegacyCondition = (
  field: IField,
  platformCondition: Condition
): LegacyCombinedCondition => {
  const filterOperators = Object.keys(platformCondition) as PlatformFilterOperator[];
  return {
    conditions: filterOperators
      .map((operator) =>
        getRegularFieldConditionValue(field, {
          [field.platformFilterNames[0]]: { [operator]: platformCondition[operator] },
        })
      )
      .filter(isDefined)
      .filter(isLegacySimpleCondition), // we're pretty sure all conditions will be simple
    operator: "AND",
  };
};

export default parseLegacyCondition;
